import { cn } from '@/lib/utils';
import React from 'react';
import { Tooltip, TooltipContent } from '../tooltip';
import { TooltipTrigger } from '@radix-ui/react-tooltip';

export type ButtonProps = {
  variant?: 'primary' | 'secondary' | 'link' | 'outlined' | 'destructive';
  icon?: React.ReactNode;
  size?: 'small' | 'large';
  tooltip?: string;
};

export default function Button(
  props: React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > &
    ButtonProps
) {
  const {
    children,
    variant = 'primary',
    icon,
    className,
    size = 'small',
    tooltip,
  } = props;

  let variantStyle = '';
  if (variant === 'primary') {
    variantStyle =
      'bg-primary text-primary-foreground shadow-sm hover:opacity-90 disabled:opacity-50';
  }
  if (variant === 'secondary') {
    variantStyle =
      'bg-secondary text-secondary-foreground border border-border hover:bg-accent hover:text-accent-foreground disabled:opacity-50';
  }
  if (variant === 'destructive') {
    variantStyle =
      'bg-destructive text-white hover:opacity-90 disabled:opacity-50';
  }
  if (variant === 'outlined') {
    variantStyle =
      'bg-transparent border border-border text-foreground hover:bg-muted disabled:opacity-50';
  }
  if (variant === 'link') {
    variantStyle = 'bg-transparent text-primary hover:underline disabled:opacity-50';
  }

  const buttonEl = (
    <button
      {...props}
      className={cn(
        'w-full flex items-center justify-center px-2 rounded-full font-semibold cursor-pointer disabled:cursor-default',
        size === 'small' ? 'py-2' : 'py-4',
        variantStyle,
        className
      )}
    >
      <div className="flex items-center justify-center gap-1">
        {icon}
        {children}
      </div>
    </button>
  );

  if (tooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{buttonEl}</TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    );
  }
  return buttonEl;
}
